import React from 'react';
import {LoadingComponent} from '../../utils/ui'
import owlResponseHelper from "../graph/owlHelper";


const settings = {
	//Флаг, что тип определяет родительский класс. Т.е. устанавливается связь rdfs:SubClassOf
	typeAsSuperClass: true,
	//Варианты xxxxxxx_AS_ERROR, xxxxxxx_AS_WARN, xxxxxxx_AS_LOG - вызывают соответствующие сообщения в консоле
	//Доступно:
	// SkipCreateType - сообщение о пропуске создания узла по его типу заданному в массиве objectNoCreated и
	//	и для которого отсутсвет условии исключения из массива settings.createTypes
	// NotSupportedType - сообщение о пропуске создания узла по его типу заданному в объекте триплета и отсутсвующего
	// 	в массиве types и settings.createNodes
	logger: ["SkipCreateType_AS_NONE", "NotSupportedType_AS_NONE"],
	settings: {createTypes:[], createNodes:[]},
};

const baseIri = "http://hbz.ru/ontologies/emd";

class VOWLMaker extends React.Component {

  constructor(props, context) {
    super(props, context)
  }

  componentDidMount() {
    this.makeVOWL()
  }

  componentWillReceiveProps(newProps) {
    this.makeVOWL()
  }

  makeVOWL(){
		//console.log("popUpVOWL.js makeVOWL()", this);
		const {content, onMakeVOWL} = this.props;
		const maker = new Promise((resolve, reject) => {
			const helper = new owlResponseHelper();
			helper.setResponse(content);
			helper.setConversionSettings(settings);
			resolve(helper.getVOWL());	
		});
		maker.then (vowl=>{
			//console.log("popUpVOWL.js makeVOWL() then", vowl, JSON.stringify(vowl));
			for (let index = 0; index < vowl.classAttribute.length; index++) {
				const element = vowl.classAttribute[index];
				if (element.iri.startsWith(baseIri))
					element.baseIri = baseIri;
			}
			onMakeVOWL(vowl);
		})
		.catch(e => { 
			console.log("popUpVOWL.js makeVOWL() catch", e);
		});
}

    render() {
        //console.log(this); 
        return (
            <div>
                <span><LoadingComponent /><p>Дождитесь окончания загрузки и парсинга содержимого ЕМД.</p></span>
            </div>
        );
    }
};

export default VOWLMaker;